"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecoaAccessCodeApi = void 0;
const verifyEcoaAccessCode = {
    method: "POST",
    url: "/ecoa/access/verify",
    reducer: resp => resp,
    errReducer: resp => resp,
};
exports.ecoaAccessCodeApi = { verifyEcoaAccessCode };
//# sourceMappingURL=ecoaAccessCode.js.map